// Mock data for Fight for Erebus Landing Page

export const gameFeatures = [
  {
    id: 1,
    title: "Elemental Combat",
    description: "Master the power of Fire, Water, Earth, and Air. Each element offers unique abilities and strategies.",
    icon: "Flame"
  },
  {
    id: 2,
    title: "1v1 PvP Battles",
    description: "Face off against opponents in intense player-versus-player combat. Skill and strategy determine victory.",
    icon: "Swords"
  },
  {
    id: 3,
    title: "Unreal Engine Graphics",
    description: "Experience stunning visuals powered by Unreal Engine. Every spell and effect comes to life.",
    icon: "Sparkles"
  },
  {
    id: 4,
    title: "Dynamic Arenas",
    description: "Battle across diverse mythical arenas in the realm of Erebus. Each arena presents tactical advantages.",
    icon: "Map"
  }
];

export const elements = [
  {
    id: 1,
    name: "Fire",
    title: "Pyromancer",
    description: "Harness devastating flames and explosive power. High damage output with aggressive playstyle.",
    color: "#ff4500",
    abilities: ["Fireball", "Flame Wall", "Inferno Strike"],
    image: "https://images.unsplash.com/photo-1572979405940-679d132c80e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxmaXJlJTIwbWFnaWN8ZW58MHx8fHwxNzcwODM2OTgyfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Water",
    title: "Hydromancer",
    description: "Control the flow of water and ice. Defensive capabilities with crowd control effects.",
    color: "#00bfff",
    abilities: ["Ice Shard", "Tidal Wave", "Frost Shield"],
    image: "https://images.unsplash.com/photo-1768813282031-2aec62eee8b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxlbGVtZW50YWwlMjBtYWdpY3xlbnwwfHx8fDE3NzA4MzY5NzZ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "Earth",
    title: "Geomancer",
    description: "Command the strength of stone and earth. Tank-like durability with powerful ground attacks.",
    color: "#8b4513",
    abilities: ["Rock Barrage", "Earthquake", "Stone Armor"],
    image: "https://images.unsplash.com/photo-1650712932372-3c381b2a71c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxlYXJ0aCUyMHJvY2tzfGVufDB8fHx8MTc3MDgzNzAwNnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    name: "Air",
    title: "Aeromancer",
    description: "Wield lightning and wind with speed. High mobility and fast-paced combat style.",
    color: "#00ff00",
    abilities: ["Lightning Bolt", "Tornado", "Wind Dash"],
    image: "https://images.unsplash.com/photo-1583459094467-e0db130c0dea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxsaWdodG5pbmclMjBzdG9ybXxlbnwwfHx8fDE3NzA4MzcwMDB8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const mockBetaRegistration = (email, element) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: "Successfully registered for beta access!",
        data: {
          email,
          element,
          registrationDate: new Date().toISOString()
        }
      });
    }, 1000);
  });
};
